import type { CatalogConstructionTypeCreateInput, CatalogConstructionTypeUpdateInput } from 'gql/graphql';
import { ConstructionTypeCodeEnum } from 'types/constructionTypeCode';

import type {
    IConstructionTypeFormValues,
    IConstructionTypeNames,
    TCatalogConstructionTypeRow,
    TConstructionTypeNameField,
} from './types';

const SYSTEM_CONSTRUCTION_TYPE_CODES = new Set<string>([
    ...Object.keys(ConstructionTypeCodeEnum),
    ...Object.values(ConstructionTypeCodeEnum),
]);

export const isSystemConstructionType = (code?: string | null) =>
    Boolean(code && SYSTEM_CONSTRUCTION_TYPE_CODES.has(code));

export const UNIQUE_NAME_ERROR = 'Вид строительства с таким наименованием уже существует';
export const UNIQUE_CODE_ERROR = 'Вид строительства с таким кодом уже существует';
export const CODE_PATTERN = /^[A-Za-z]+$/;

export const CONSTRUCTION_TYPE_NAME_FIELDS: { field: TConstructionTypeNameField; label: string }[] = [
    { field: 'name', label: 'Наименование в системе' },
    { field: 'fullName', label: 'Полное наименование' },
    { field: 'shortName', label: 'Короткое наименование' },
    { field: 'contractFileName', label: 'Наименование в рассчетном файле' },
];

export const getConstructionTypeFormValues = (
    row?: TCatalogConstructionTypeRow | null,
): IConstructionTypeFormValues => ({
    code: row?.code ?? '',
    name: row?.name ?? '',
    fullName: row?.fullName ?? '',
    shortName: row?.shortName ?? '',
    contractFileName: row?.contractFileName ?? '',
    iconCode: row?.iconCode ?? null,
});

export const trimValue = (value?: string | null) => (value ?? '').trim();

export const trimConstructionTypeNames = (values: IConstructionTypeNames): IConstructionTypeNames => ({
    name: trimValue(values.name),
    fullName: trimValue(values.fullName),
    shortName: trimValue(values.shortName),
    contractFileName: trimValue(values.contractFileName),
});

export const buildCreateConstructionTypeInput = ({
    values,
    catalogId,
}: {
    values: IConstructionTypeFormValues;
    catalogId: number;
}): CatalogConstructionTypeCreateInput => ({
    ...trimConstructionTypeNames(values),
    iconCode: values.iconCode,
    code: trimValue(values.code),
    catalogId,
});

export const buildUpdateConstructionTypeInput = ({
    values,
    row,
    catalogId,
}: {
    values: IConstructionTypeFormValues;
    row: TCatalogConstructionTypeRow;
    catalogId: number;
}): CatalogConstructionTypeUpdateInput => ({
    ...trimConstructionTypeNames(values),
    iconCode: values.iconCode,
    code: row.code,
    id: row.id,
    catalogId,
});
